module.exports = "/_next/static/images/MobileSecondProcess-020a7545ee34a90562daace0696f9c23.png";